<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Noise Abatement</h2>
    <button id="addNoiseButton" (click)="openEditNoiseDialog(null)" mat-mini-fab *ngIf="editModeSet">
      <mat-icon aria-label="Add Noise Abatement">add</mat-icon>
    </button>
  </div>
  <div class="section__body">
    <table *ngIf="airport.noiseAbatement.length; else placeholder" class="data-block data-block--lg">
      <thead>
        <tr>
          <th *ngIf="editModeSet" class="data-block__label">Actions:</th>
          <th class="data-block__label">Runway:</th>
          <th class="data-block__label">Applies to:</th>
          <th class="data-block__label">Approach/Departure:</th>
          <th class="data-block__label">Text:</th>
        </tr>
      </thead>
      <tbody>
        <tr class="data-block__item" *ngFor="let procedure of airport.noiseAbatement; let i = index">
          <td *ngIf="editModeSet" class="data-block__value">
            <div class="noise__actions">
              <mat-icon (click)="openEditNoiseDialog(i)" *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit noise abatement">edit</mat-icon>
              <mat-icon (click)="deleteNoise(i)" *ngIf="editModeSet" class="delete-icon" mat-tooltip="Delete" aria-label="Delete noise abatement">delete_outline</mat-icon>
            </div>
          </td>
          <td class="data-block__value">
            <ng-container *ngIf="procedure.runway; else na">{{ procedure.runway }}</ng-container>
          </td>
          <td class="data-block__value">
            {{ formatAppliesTo(procedure.appliesTo) }}
          </td>
          <td class="data-block__value">
            {{ formatAppDep(procedure.appDep) }}
          </td>
          <td class="data-block__value">
            <ng-container *ngIf="procedure.text; else na">{{ procedure.text }}</ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<ng-template #na>
  <span class="na">N/A</span>
</ng-template>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">No noise abatement procedures provided by airport manager. Please check Additional Remarks section for FAA generated noise abatement procedures.</div>
  </div>
</ng-template>
